<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Get Compliance Rule</div>
        <div>
          <!-- <bread-crumb :bread-crumbs="['Compliance Rule']" /> -->
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-row class="d-flex justify-between mt-2 me-3 mb-2">
        <v-btn depressed 
          @click="downloadExcelsheet"
          class="mb-4 ms-5"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-btn depressed 
          color="primary"
          small
          class="mb-4 text-capitalize ms-3"
          @click="route"
        >
          New
        </v-btn>
      </v-row>
      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="compliance_Rule"
        :items-per-page="10"
        dense
      >
        <template v-slot:item.number="{ item }">
          <td>
            <div class="subtitle-1">
              {{ item.id }}
            </div>
          </td>
        </template>

        <template v-slot:item.action="{ item }">
          <div class="subtitle-1">
            <v-icon small class="pe-2" :color="item.is_enable ? 'green' : 'red'"
              >mdi-check-circle</v-icon
            ><v-icon
              class="mr-2"
              color="primary"
              small
              @click="
                $router.push({
                  name: 'Compliance Rules New',
                  query: { id: item.id },
                })
              "
            >
              mdi-content-save-edit-outline
            </v-icon>
          </div>
        </template>
      </v-data-table>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import setupService from "@/services/SetupService/setupService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
export default {
  name: "Compliance Rules",
  mixins: [alerts],
  components: {
    OverlayPageVue,
  },
  data() {
    return {
      loaderOverlay: false,
      headers: [
        {
          text: "SNo",
          align: "start",
          sortable: false,
          value: "number",
        },
        { text: "Rule Name", value: "rule_name" },
        { text: "Sender Country", value: "sender_country" },
        { text: "Payout Country", value: "payout_country" },
        { text: "Payment Mode", value: "payment_mode" },
        { text: "Compliance Group Code", value: "compliance_grp_code" },
        { text: "Apply If AMT More", value: "if_amount" },
        { text: "Apply If NOS of TXN More", value: "no_of_transactions" },
        { text: "Validation MSG", value: "description" },
        { text: "Action", value: "action" },
      ],
      compliance_Rule: [],
    };
  },
  mounted() {
    this.getCompliceRules();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.compliance_Rule) {
        this.exportToExcel(
          this.headers,
          this.compliance_Rule,
          "compliance_Rule"
        );
      }
    },
    async getCompliceRules() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getrules();
        if (response.data.status_code === 200) {
          this.compliance_Rule = response.data.data;
          console.log("compliance_Rule", this.compliance_Rule);
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.compliance_Rule = [];
        //   this.returnNewToken();
        //   this.getCompliceRules();
        //   this.stoploader();
        // }
        else {
          this.compliance_Rule == [];
          this.stoploader();
        }
      } catch (error) {
        this.compliance_Rule = [];
        this.stoploader();
        console.error(error);
      }
    },
    route() {
      this.$router.push({
        path: "/complianceRulesNew",
      });
    },
  },
};
</script>

<style></style>
